// extracted by mini-css-extract-plugin
export default {"hero":"style_hero__FhLnJ","herocontainer":"style_herocontainer__ktkgo","title":"style_title__UiTMg","desc":"style_desc__VuPQj","container":"style_container__Wrwh-"};